import { createSlice } from "@reduxjs/toolkit";
import {
  fetchBildirimler,
  markNotificationAsRead,
  deleteNotification,
} from "../actions/bildirimActions";

const initialState = {
  notifications: [],
  unreadCount: 0,
  loading: false,
  error: null,
};

const bildirimSlice = createSlice({
  name: "bildirim",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchBildirimler.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBildirimler.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications = action.payload;
        state.unreadCount = action.payload.filter((n) => !n.read).length;
      })
      .addCase(fetchBildirimler.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Mark as read cases
      .addCase(markNotificationAsRead.fulfilled, (state, action) => {
        const notificationId = action.payload;
        state.notifications = state.notifications.map((notification) =>
          notification._id === notificationId
            ? { ...notification, read: true }
            : notification
        );
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      })
      .addCase(deleteNotification.fulfilled, (state, action) => {
        state.notifications = state.notifications.filter(
          (notification) => notification._id !== action.payload
        );
        state.unreadCount = state.notifications.filter((n) => !n.read).length;
      });
  },
});

export default bildirimSlice.reducer;
